import { Directive, input } from '@angular/core';

import { ArrowIconsType } from './arrows';
import { BaseIconDirective } from './base-icon.directive';

@Directive({
  selector: 'svg[dmcomUseArrowIcon]',
  standalone: true,
})
export class UseArrowIconDirective extends BaseIconDirective {
  public readonly dmcomUseArrowIcon = input.required<ArrowIconsType>();
  readonly BASE_PATH = '/assets/ui-components/arrows.sprites.svg';

  public get icon() {
    return this.dmcomUseArrowIcon();
  }
}
